import React from "react";
import { Link, useParams } from "react-router-dom";
import { useMedia } from "react-use";
import {
  Add as AddIcon,
  Done as DoneIcon,
  MoreHoriz as MoreHorizIcon,
} from "@mui/icons-material";
import {
  Button,
  ClickAwayListener,
  Grow,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { config as cssConfig, Flex } from "@100mslive/roomkit-react";
import {
  FileIcon,
  Grid,
  LogoIcon,
  SettingIcon,
  VerifedIcon,
} from "../../icons";
import { SESSION_AUTH } from "../../common/auth";

const CompanyBanner = props => {
  const { orgSlug } = useParams();
  const { companyData, handleWatching, handleLogin, handleProfileAction } =
    props;
  const { isUserSession } = SESSION_AUTH();
  const isMobile = useMedia(cssConfig.media.sm);

  const [actionMenu, setActionMenu] = React.useState(false);
  const anchorRef = React.useRef(null);

  const actionMenuToggle = () => {
    setActionMenu(prevOpen => !prevOpen);
  };
  const actionMenuClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setActionMenu(false);
  };

  return (
    <React.Fragment>
      <Flex className="event-page-company-banner events6ix-layout-page-header2">
        <Link
          to={`/company/${orgSlug}`}
          className="events6ix-layout-page-header2-content"
        >
          <div
            className="events6ix-layout-page-header2-content-logo"
            style={{
              backgroundColor: companyData?.orgLogoColor
                ? companyData?.orgLogoColor
                : "",
            }}
          >
            {companyData?.orgLogo ? (
              <img src={companyData?.orgLogo} alt="logo" />
            ) : (
              <LogoIcon />
            )}
          </div>
          <div className="events6ix-layout-page-header2-content-info">
            <Flex className="events6ix-layout-page-header2-content-info-name">
              {companyData?.orgName}{" "}
              {companyData?.isVerified ? <VerifedIcon /> : <></>}
            </Flex>
          </div>
        </Link>
        <Flex className="events6ix-layout-page-header2-action">
          {isUserSession ? (
            <>
              {companyData?.isWatching ? (
                <Button
                  size={isMobile ? "small" : ""}
                  variant="outlined"
                  className="events6ix-btn events6ix-btn-light events6ix-btn-sm"
                  type="button"
                  sx={{ textTransform: "none" }}
                  startIcon={<DoneIcon />}
                  onClick={() => {
                    handleWatching("remove");
                  }}
                >
                  Watching
                </Button>
              ) : (
                <Button
                  size={isMobile ? "small" : ""}
                  variant="outlined"
                  className="events6ix-btn events6ix-btn-light events6ix-btn-sm"
                  type="button"
                  sx={{ textTransform: "none" }}
                  startIcon={<AddIcon />}
                  onClick={() => {
                    handleWatching("add");
                  }}
                >
                  Add to Watch List
                </Button>
              )}
              {companyData?.isOwner ||
              companyData?.isAdmin ||
              companyData?.isMember ? (
                <div className="events6ix-dropdown">
                  <Button
                    variant="outlined"
                    ref={anchorRef}
                    className={`events6ix-dropdown-btn events6ix-btn events6ix-btn-sm ${
                      actionMenu
                        ? "events6ix-btn-primary"
                        : "events6ix-btn-light"
                    }`}
                    id="company-profile-banner-action-button"
                    aria-controls={
                      actionMenu
                        ? "company-profile-banner-action-menu"
                        : undefined
                    }
                    aria-expanded={actionMenu ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={actionMenuToggle}
                  >
                    <MoreHorizIcon />
                  </Button>

                  <Popper
                    open={actionMenu}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-end"
                    transition
                    disablePortal
                    className="events6ix-dropdown-menu"
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom-end"
                              ? "right top"
                              : "right bottom",
                        }}
                      >
                        <Paper>
                          <ClickAwayListener onClickAway={actionMenuClose}>
                            <MenuList
                              autoFocusItem={actionMenu}
                              id="company-profile-banner-action-menu"
                              aria-labelledby="company-profile-banner-action-button"
                              className="events6ix-dropdown-list"
                            >
                              <MenuItem
                                className="events6ix-dropdown-list-item"
                                onClick={e => {
                                  handleProfileAction("/account/setting");
                                  actionMenuClose(e);
                                }}
                              >
                                <SettingIcon />
                                <ListItemText>
                                  Organization Settings
                                </ListItemText>
                              </MenuItem>
                              <MenuItem
                                className="events6ix-dropdown-list-item"
                                onClick={e => {
                                  handleProfileAction("/dashboard");
                                  actionMenuClose(e);
                                }}
                              >
                                <Grid />
                                <ListItemText>Dashboard</ListItemText>
                              </MenuItem>
                              <MenuItem
                                className="events6ix-dropdown-list-item"
                                onClick={e => {
                                  handleProfileAction("/investors");
                                  actionMenuClose(e);
                                }}
                              >
                                <FileIcon />
                                <ListItemText>Report</ListItemText>
                              </MenuItem>
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </div>
              ) : null}
            </>
          ) : (
            <Button
              size={isMobile ? "small" : ""}
              variant="outlined"
              className="events6ix-btn events6ix-btn-light events6ix-btn-sm"
              type="button"
              sx={{ textTransform: "none" }}
              startIcon={<AddIcon />}
              onClick={handleLogin}
            >
              Add to Watch List
            </Button>
          )}
        </Flex>
      </Flex>
    </React.Fragment>
  );
};

export default CompanyBanner;
